<template>
  <div id="app" v-if="isMobileStatus">
    <router-view />
  </div>
  <div id="app" v-else>
    <div style="height: 90px;">
      <el-container class="center-just container">
        <Header></Header>
      </el-container>
    </div>
    <!-- <Sidebar></Sidebar> -->
    <!-- <div style="height: 900px;background: violet;">ddd</div> -->
    <!-- <el-image
      :src="$domain + 'static/noten/website/newHome/top_banner1.png'"
      alt="编程"
      style="width: 100%;height: 600px;"
    ></el-image> -->
    <el-backtop :bottom="100" style="width: 100px;">
      <div class="up">返回顶部</div>
    </el-backtop>

    <router-view />
    <Intro></Intro>
    <!-- <Footer></Footer> -->
  </div>
</template>

<script>
import Intro from "@/components/Intro";
import Sidebar from "@/components/sidebar.vue";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HelloWorld from "@/components/HelloWorld";
export default {
  name: "App",
  components: { Header, Footer, HelloWorld, Sidebar, Intro },
  data() {
    return { isMobileStatus: false };
  },
  mounted() {
    this.isMobile();
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      console.log("flag", flag);
      if (flag) {
        this.isMobileStatus = true;
      }
    }
  }
};
</script>

<style lang="scss">
#app {
  padding: 0;
}
body {
  margin: 0;
}

.up {
  height: 100%;
  width: 100%;
  background-color: #f2f5f6;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
  text-align: center;
  line-height: 40px;
  color: #1989fa;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 1px;
}

.container {
  background-color: #ffffff;
  width: 100%;
  position: relative;
  height: 80px;
  // /* position: fixed; */
  // /* z-index: 10000; */
  // /* top: 0; */
}

.center {
  display: flex;
  justify-content: center;
}

.center-just {
  display: flex;
  justify-content: center;
  align-items: center;
}

// /* 纵向排列 */
.column {
  display: flex;
  flex-direction: column;
}

.row {
  display: flex;
  flex-direction: row;
}

// /* 横向向两端对齐 */
.between {
  display: flex;
  justify-content: space-between;
}

// /* 纵向两端对齐 */
.column-between {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
// /* 横向等比平分 */
.space {
  display: flex;
  justify-content: space-around;
}

// /* 纵向等比平分 */
.column-space {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
</style>



// WEBPACK FOOTER //
// src/App.vue